import { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLazyLoadQuery } from "react-relay";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { ModuleRatingDetailsContextProvider } from "./module-rating-details.context";
import { NODE_QUERY } from "./module-ratings-details.graphql";
import { ModuleRatingDetailsChart } from "./parts/chart/module-rating-details-chart.component";
import { ModuleRatingDetailsTableFilters } from "./parts/filters";
import { ModuleRatingDetailsTable } from "./parts/table";
import { Permission } from "../../../__generated__/MainNavigation_Query.graphql";
import { moduleRatingsDetails_Query } from "../../../__generated__/moduleRatingsDetails_Query.graphql";
import { selectHasPermissions } from "../../../infecto-lms-admin/redux/slices/CurrentUserSlice";
import { ReduxState } from "../../../infecto-lms-admin/redux/Store";
import { BaseScreen } from "../../../infecto-lms-admin/screens/BaseScreen";

export const ModuleRatingDetails = () => {
	const { id } = useParams<{ id: string }>();
	useRedirectOnMissingId(id);

	const query = useLazyLoadQuery<moduleRatingsDetails_Query>(NODE_QUERY, {
		nodeRef: "TGVhcm5PcHBvcnR1bml0eVYyOmZkNzcxM2Y4LTg0NjMtNGI2MS05MWRkLWVmNWNiNTJjZjA3Zg==",
	});
	const isAdmin = useCheckPermission([
		"AccountPermission_System_Root",
		"UserInAccountPermission_System_Owner",
	]);

	if (!isAdmin) {
		return <div>Kein Zugriff</div>;
	}

	return (
		<BaseScreen>
			<h1>Modul-Bewertungen: {query.node?.structureDefinition?.title}</h1>
			<ModuleRatingDetailsContextProvider>
				<div className={"flex flex-column gap-2"}>
					<Suspense fallback={<div>Lade...</div>}>
						{id && <ModuleRatingDetailsChart id={id} />}
					</Suspense>
					<ModuleRatingDetailsTableFilters />
					<Suspense fallback={<div>Lade...</div>}>
						<ModuleRatingDetailsTable id={id!} />
					</Suspense>
				</div>
			</ModuleRatingDetailsContextProvider>
		</BaseScreen>
	);
};

const useCheckPermission = (permissions: Permission[]) =>
	useSelector((state: ReduxState) => selectHasPermissions(state, permissions));

const useRedirectOnMissingId = (id?: string) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (id) return;

		navigate("/");
	}, [id]);
	return;
};
